<!--
  XXX  diff w/ src/components/Widgets/AdminReports/AdminActivityContainer.vue
-->
<template>
  <div class="h-100">
    <activity
      :entries="entries"
      title="Activity"
      :loading="loading"
    />
  </div>
</template>
<script>
import Activity from '@/components/Widgets/Reports/Activity';

export default {

  name: 'AssociateActivityContainer',
  components: {
    Activity,
  },
  props: {
    dataRange: {
      type: String,
      required: true,
    },
    profileId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    stats() {
      const result = this.$store.state.profiles.itemStats;
      return result;
    },
    loading() {
      return this.$store.state.profiles.itemStatsLoading;
    },
    entries() {
      if (!this.stats) return [];
      return [{
        label: 'Total Clients',
        value: this.stats.total_clients,
      }, {
        label: 'Book Penetration',
        value: this.stats.penetration,
        formatter: this.formatPercent,
      }, {
        label: 'Edits Created',
        value: this.stats.campaigns,
      }, {
        label: 'Emails Sent',
        value: this.stats.sent,
      }, {
        label: 'PDFs Created',
        value: this.stats.pdfs_created,
      }, {
        label: 'Share Links Created',
        value: this.stats.links_created,
      }].map(({ label, value, formatter }) => {
        const formatted = formatter ? formatter(value) : this.formatGeneric(value);
        return {
          label,
          value: formatted,
        };
      });
    },
  },
  watch: {
    dataRange() {
      this.fetchStatsRange();
    },
    profileId: {
      immediate: true,
      handler: (newId, oldId) => {
        if (newId && oldId && newId !== oldId) {
          this.fetchStatsRange();
        }
      },
    },
  },
  mounted() {
    this.fetchStatsRange();
  },
  methods: {
    fetchStatsRange() {
      this.$store.dispatch('profiles/fetchItemStats', { id: this.profileId, range: this.dataRange });
    },
    formatPercent(num) {
      return this.isNull(num) ? '--' : `${this.$options.filters.formatFloat(num * 100, 1)}%`;
    },
    isNull(value) {
      // eslint-disable-next-line
      return value === null || value === undefined || isNaN(value)
    },
    formatGeneric(value) {
      return this.isNull(value) ? '--' : value;
    },
  },
};
</script>
<style lang="css"
  scoped>
</style>
